<template>
    <provider-wrapper
        :element="element"
        :layer="layer"
        inject-key="publishInfoTable">

        <slot />

    </provider-wrapper>
</template>

<script>
import ProviderWrapper from './providerWrapper.js'

export default {
    components: { ProviderWrapper },
    props: {
        /** @type {PublishTableLayer} */
        layer: Object,

        /** @type {PublishTableElement} */
        element: Object
    }
}
</script>

